module.exports = __webpack_public_path__ + "static/media/accessoires.8667500b.jpg";